import { render, staticRenderFns } from "./CustomerComplaintUserAnswered.vue?vue&type=template&id=3d6447f3&"
import script from "./CustomerComplaintUserAnswered.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintUserAnswered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports